import { render } from "./employee_salary_tab.vue?vue&type=template&id=d667562e"
import script from "./employee_salary_tab.vue?vue&type=script&lang=js"
export * from "./employee_salary_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__